import React, { useState } from 'react';
import { ContentTemplate, Grid, KeyValue, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import TaskFileBadge from 'web-library/components/TaskFileBadge';
import { WithdrawDetails } from '../../api/candidate/exam/model';
import { WithdrawalReviewResponse } from '../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalReview';
import { useGetDocumentUploadStatus } from '../../api-refactored/document/useGetDocumentUploadStatus';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  subheader: {
    marginBottom: theme.spacing(4),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(4),
  },
}));

interface ReviewWithdrawalDataTableProps {
  withdrawalDetails: WithdrawDetails | WithdrawalReviewResponse;
  isSectionHeader: boolean;
}

const ReviewWithdrawalDetails = ({
  withdrawalDetails,
  isSectionHeader,
}: ReviewWithdrawalDataTableProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [fileUuid, setFileUuid] = useState<string>('');

  useGetDocumentUploadStatus({
    fileKey: fileUuid || '',
    enabled: !!fileUuid && fileUuid !== '',
    refetchInterval: undefined,
    onSuccess: (res) => {
      if (res.url) {
        const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
          newWindow.opener = null;
        }
        setFileUuid('');
      }
    },
  });

  return (
    <ContentTemplate isDividerBottom type="large" continuous={!isSectionHeader}>
      <Grid>
        {isSectionHeader && (
          <SectionHeader title={t('withdrawal->>ReviewWithdrawal.ReviewDetails')} />
        )}
        <Typography variant="h3" className={classes.subheader}>
          {t('withdrawal->>ReviewWithdrawal.WithdrawalDetails')}
        </Typography>
        <Grid>
          <KeyValue
            id="reasonForWithdrawal"
            keyText={t('withdrawal->>ReviewWithdrawal.ReasonForWithdrawal')}
            valueText={withdrawalDetails.reasonSelected}
            capitalize={false}
          />
        </Grid>
        {withdrawalDetails.specifiedReason && (
          <Grid>
            <KeyValue
              id="reasonForWithdrawal"
              keyText={t('withdrawal->>ReviewWithdrawal.SpecifiedReason')}
              valueText={withdrawalDetails.specifiedReason}
              capitalize={false}
            />
          </Grid>
        )}
        <Grid>
          <KeyValue
            id="attachedFile"
            keyText={t('withdrawal->>ReviewWithdrawal.AttachedFile')}
            valueText={
              <Grid className={classes.documentsContainer}>
                {withdrawalDetails.fileNames.length === 0 ? (
                  <>-</>
                ) : (
                  <>
                    {withdrawalDetails.fileNames.map((file) => {
                      if (isSectionHeader || !file.draft) {
                        return (
                          <TaskFileBadge
                            key={file.id}
                            file={{
                              fileUuid: file.uuid,
                              fileName: file.fileName,
                              fileSizeInBytes: file.fileSize,
                              submitted: !file.draft,
                            }}
                            setFileUuid={setFileUuid}
                          />
                        );
                      }
                      return null;
                    })}
                  </>
                )}
              </Grid>
            }
            capitalize={false}
          />
        </Grid>
      </Grid>
    </ContentTemplate>
  );
};

export default ReviewWithdrawalDetails;
